import * as React from 'react'
import getDealerAdInfo, { DealerAdInfo } from 'Services/dealer_ad'
import { useCityName } from 'Components/hooks'

type DealerAdInfoParams = {
  ritIds: string
  effectTag?: boolean
}

const useDealeradInfo = ({
  ritIds,
  effectTag = true,
}: DealerAdInfoParams): { dealeradInfo?: DealerAdInfo } => {
  const [dealeradInfo, setDealeradInfo] = React.useState<DealerAdInfo>()
  const cityName = useCityName()
  React.useEffect(() => {
    if (effectTag && typeof cityName !== 'undefined') {
      getDealerAdInfo({ city_name: cityName, rit_ids: ritIds }).then(
        setDealeradInfo
      )
    }
  }, [effectTag, ritIds, cityName])

  return { dealeradInfo }
}

export default useDealeradInfo
